/**
 * Created by rak on 8/24/2016.
 */
'use strict';
angular.module('betosyswebapp').directive('driverWrkHrsSvgInterpreter', function ($translate, $timeout, commonTrackService, AuthenticationService, localStorageService, $window, tachoHistoryService, DriverWrkHrsWidgetService, $rootScope, stateManagerService, DriverWrkHrsSVGWidgetService) {
  return {
    restrict: 'E',
    replace: true,
    template: '<object id="wrkHrsSvg" data="assets/images/driverWorkingHours.svg" width="100%" type="image/svg+xml" ng-show="hasValidDriver"></object>',
    link: function (scope, element) {
      scope.hasValidDriver = true;
      scope.isNotAuthorized = false;
      scope.isDataNotAvailable = false;
      scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
      scope.isWidgetPostInitFinished = false;


      var loginid = AuthenticationService.GetLoginID();
      var localstorageWorkingHoursType = localStorageService.get('selectedWorkingHourType.' + loginid.Account + '.' + loginid.username);
      scope.timeRadio = {
        type: localstorageWorkingHoursType && localstorageWorkingHoursType.workingHourType ? localstorageWorkingHoursType.workingHourType : 'totalTime',
        svgRadioType: localstorageWorkingHoursType && localstorageWorkingHoursType.svgRadioType ? localstorageWorkingHoursType.svgRadioType : 'workTime',
        viewType: {
          dailyView: localstorageWorkingHoursType && localstorageWorkingHoursType.viewType && localstorageWorkingHoursType.viewType.dailyView ? localstorageWorkingHoursType.viewType.dailyView : true,
          weeklyView: localstorageWorkingHoursType && localstorageWorkingHoursType.viewType && localstorageWorkingHoursType.viewType.weeklyView ? localstorageWorkingHoursType.viewType.weeklyView : false
        }

      };


      var isWidgetUnderDialog = element.parents('.modal-body').length || 0;

      if (isWidgetUnderDialog) {
        element.width('500px');
      }

      var _7_30_M = 450;
      var _10_M = 600;
      var _8_0_M = (8 * 60);
      var _8_30_M = 510;
      var _4_M = 240;
      var _4_30_M = 270;
      var _5_30_M = 330;
      var _6_0_M = 360;
      var _9_0_M = 540;
      var _48_0_M = 48 * 60;
      var _60_0_M = 60 * 60;
      var _56_0_M = 56 * 60;
      var _80_0_M = 80 * 60;
      var _90_0_M = 90 * 60;
      var _2_30_M = (2 * 60) + 30;
      var _1_30_M = 90;
      var _12_0_M = (12 * 60);
      var TIME_STRING_FORMAT = {
        _1: '0d 00h 00m', // if days are present  time display in '12d 12h 12m' else '00h 12m'
        _2: '00h 00m'// if hours presnt '12h 12m' else '00h 12m'
      };

      scope.max = 100;
      scope.driverWorkHours = restProgressBarDetails();

      function restProgressBarDetails() {
        return {
          workTimeTotal: { type: 'info', value: 0, actualValue: '' },
          driveTimeTotal: { type: 'info', value: 0, actualValue: '' },
          workTimePause: { type: 'info', value: 0, actualValue: '' },
          driveTimePause: { type: 'info', value: 0, actualValue: '' },
          weekWorkTimeTotal: { type: 'info', value: 0, actualValue: '' },
          weekDriveTimeTotal: { type: 'info', value: 0, actualValue: '' },
          weekDriveTimeTotal2we: { type: 'info', value: 0, actualValue: '' },
        };
      }


      var totalCircle = 360;
      var totalBar = 100;
      var totlWrkHrsLimtMinutes = 600; // 10 hours normal worktime
      var totlExtraWrkHrsLimitMinutes = 240; //  maximum Extra work time Limit 4 hours.

      var workTimeMaxLimitMinutes = 600;  // 10 hours normal worktime
      var driveTimeTotalMaxLimitMinutes = 600; // 10 hours normal drive time
      /*    var pauseTimeTotalMaxLimitMinutes = 45; // 45 min normal break time
       var standbyTimeTotalMaxLimitMinutes = 60; // 1 hour normal stand by time ?*/
      var workTimeBetweenPauseMaxLimitMinutes = 360; // 4 hour normal beak time between pause
      var driveTimeBetweenPauseMaxLimitMinutes = 270; // 4 hour normal drive time between pause

      var weeklyDetailWorkTimeTotalMaxLimitMinuts = 60 * 60;
      var weeklyDetailDriveTimeTotalMaxLimitMinuts = 56 * 60;
      var weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts = 90 * 60;

      var wrkHrsCircleId = 'group_ue_rpb_normal';
      var wrkHrsOverAllPercentId = 'ue_label_overal_percentage';
      var driverDescId = 'group_ue_overal_driver_status';
      var remaingWrktimeLabel = 'ue_label_rem_workingtime';
      var remWrkHrsLabel = 'ue_label_descr';


      var driverDesTemplate = '<text xmlns="http://www.w3.org/2000/svg" id="label_driver_desc" transform="matrix(0.9986 0 0 1 90 22.7041)" style="text-anchor: middle;" font-family="Roboto,Calibri"';
      var dirverStateTemplate = '<text xmlns="http://www.w3.org/2000/svg" id="label_driver_state" transform="matrix(0.9986 0 0 1 90 32.7041)" style="text-anchor: middle;" font-family="Roboto,Calibri" font-size="10">';
      var extrWrkHrsCircleId = 'group_ue_rpb_overtime';

      var _tmp = 0;
      var greenWrkHrsCircleArry = [];
      var redWrkHrsCircleArry = [];
      scope.isDataFromHistoryList = false;

      var h = $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.hour');
      var m = $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.minute');

      function getSvgDocument() {
        return document.getElementById('wrkHrsSvg').contentDocument;
      }

      var init = function () {
        var _isIntialized = false;
        $timeout(function () {
          $rootScope.$broadcast('reqDataUpdate');
        }, 0);


        function _handleRowSlectEvnt(data) {
          scope.isDataNotAvailable = false;
          if (data.selectedRow) {
            updateSvg(data);
          } else {
            scope.hasValidDriver = false;
          }
        }

        function _refreshSvgBasedOnLastSelectedData() {
          var _rowData = null;
          if ($window.location.href.indexOf('tachohistorydashboard') > -1) {
            _rowData = tachoHistoryService.getLastSelectedHstoryRowData();
            scope.isDataFromHistoryList = true;
          } else {
            _rowData = commonTrackService.getDriverDashboardLastSelectedRowData();
          }

          if (_rowData && _rowData !== null && _rowData.selectedRow) {

            scope.isDataNotAvailable = false;
            updateSvg(_rowData);
            _isIntialized = true;
          }
        }

        if (isWidgetUnderDialog && !_isIntialized || !_isIntialized) {
          _refreshSvgBasedOnLastSelectedData();
        }

        function updateSvg(data) {
          var _defaltTransStringPath = 'dashBoard.fleetManagement.driverWhrkHrsSVG.';

          scope.workTimeTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'workingTimeLabel') : $translate.instant(_defaltTransStringPath + 'workingTimeRemainingLabel');
          scope.workTimeBetTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'workingBetweenBreakLabel') : $translate.instant(_defaltTransStringPath + 'workingBetweenBreakRemainingLabel');
          
          //Set the max for the progress bar to drivetimelimit once we have the data
          //And set the text for the progress bar once we have the data
          if(data.selectedRow.drivetimelimit === undefined || data.selectedRow.drivetimelimit === null) {
            data.selectedRow.drivetimelimit = 10;
          }
          driveTimeTotalMaxLimitMinutes = data.selectedRow.drivetimelimit * 60;
          var _defaultDrivingTimeLimit = 'drivingTimeLabel10h';
          if(data.selectedRow.drivetimelimit === '9') {
            _defaultDrivingTimeLimit = 'drivingTimeLabel9h';
          }
          scope.driveTimeTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + _defaultDrivingTimeLimit) : $translate.instant(_defaltTransStringPath + 'drivingTimeRemainingLabel');

          scope.driveTimeBetTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'drivingBetweenBreakLabel') : $translate.instant(_defaltTransStringPath + 'drivingBetweenBreakRemainingLabel');
          scope.totalTimeRadio = $translate.instant(_defaltTransStringPath + 'totalTimeRadio');
          scope.remainingTimeRadio = $translate.instant(_defaltTransStringPath + 'remainingTimeRadio');

          scope.weeklyWorkTimeTotalLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'weeklyDetails.workTimeTotalLabel') : $translate.instant(_defaltTransStringPath + 'weeklyDetails.workTimeTotalRemainingLabel');
          scope.weeklyDriveTimeTotalLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotalLabel') : $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotalRemainingLabel');
          scope.weekly2WeeksDriveTimeTotalLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotal2WeekLabel') : $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotal2WeekRemainingLabel');
          scope.weeklyWorkTime16WeekAvgLabel = $translate.instant(_defaltTransStringPath + 'weeklyDetails.workTimeTotalAvg16weekLabel');

          //data.selectedRow.driverdesc = data.selectedRow.driverdesc && data.selectedRow.driverdesc !== '' ? data.selectedRow.driverdesc : '---';
          if (data.selectedRow.driverdesc && data.selectedRow.driverdesc !== '') {
            scope.hasValidDriver = true;
            scope.isDataNotAvailable = false;
          } else {
            scope.hasValidDriver = false;
            scope.isDataNotAvailable = true;
          }
          scope.driverWorkHours = restProgressBarDetails();
          scope.driverWorkHours.avg16WeekWorkTime = {
            actualValue: '',
            value: ''
          };

          $timeout(function () {

            var _workTimeTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.worktimetotal);

            var _driveTimeTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.drivetimetotal);
            var _workTimeBetweenPauseTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.worktimebetweenpause);
            var _driveTimeBetweenPauseTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.drivetimebetweenpause);

            var _pauseTimeTotal = _convertGtsTimeStringToMinutes(data.selectedRow.pausetimetotal);

            var _weekWorkTimeTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.weekworktimetotal, true);
            var _weekDriveTimeTotal = _convertGtsTimeStringToMinutes(data.selectedRow.weekdrivetimetotal, true);
            var _weekDriveTimeTotal2we = _convertGtsTimeStringToMinutes(data.selectedRow.weekdrivetimetotal2we, true);
            var _avg16WeekWorkTime = _convertGtsTimeStringToMinutes(data.selectedRow.worktimeavg16we, true);

            var wrkHrsCircleElement = getSvgElementByID(wrkHrsCircleId);
            var wrkHrsOverAllPercentElement = getSvgElementByID(wrkHrsOverAllPercentId);
            var extrWrkHrsCircleElement = getSvgElementByID(extrWrkHrsCircleId);
            var driverDescriptionElement = getSvgElementByID(driverDescId);

            driverDescriptionElement.children().last().remove();


            if (_tmp === 0) {
              var _wrkHrschildren = wrkHrsCircleElement.children();
              var _extraWrkHrsChildren = extrWrkHrsCircleElement.children();

              greenWrkHrsCircleArry = _loopAndGetElements(_wrkHrschildren, greenWrkHrsCircleArry);
              redWrkHrsCircleArry = _loopAndGetElements(_extraWrkHrsChildren, redWrkHrsCircleArry);

              //wrkHrs = Math.floor(Math.random() * 600) + 1; // used to test circle generation with random numbers.
            }
            wrkHrsCircleElement.empty();
            extrWrkHrsCircleElement.empty();


            ++_tmp;
            getSvgElementByID(remWrkHrsLabel).html('');


            var fontStyles = ' font-size="21">';

            if (data.selectedRow.driverdesc.length > 20) {
              //set font to 12
              fontStyles = ' font-size="12">';
            }

            if (data.selectedRow.driver1workingstate) {
              driverDescriptionElement.html(driverDesTemplate + fontStyles + data.selectedRow.driverdesc + '</text>' + dirverStateTemplate + '(' + data.selectedRow.driver1workingstate + ')</text>');
            } else {
              driverDescriptionElement.html(driverDesTemplate + fontStyles + data.selectedRow.driverdesc + '</text>');
            }

            switch (scope.timeRadio.svgRadioType) {
              case 'workTime':
                updateSvgCircle(_workTimeTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, totlWrkHrsLimtMinutes);
                break;
              case 'workTimeBetweenPause':
                updateSvgCircle(_workTimeBetweenPauseTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, workTimeBetweenPauseMaxLimitMinutes);
                break;
              case 'driveTime':
                updateSvgCircle(_driveTimeTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, driveTimeTotalMaxLimitMinutes);
                break;
              case 'driveTimeBetweenPause':
                updateSvgCircle(_driveTimeBetweenPauseTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, driveTimeBetweenPauseMaxLimitMinutes);
                break;
              case 'weekWorkTimeTotal':
                updateSvgCircle(_weekWorkTimeTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, weeklyDetailWorkTimeTotalMaxLimitMinuts);
                break;
              case 'weekDriveTimeTotal':
                updateSvgCircle(_weekDriveTimeTotal, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, weeklyDetailDriveTimeTotalMaxLimitMinuts);
                break;
              case 'weekDriveTimeTotal2we':
                updateSvgCircle(_weekDriveTimeTotal2we, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts);
                break;

            }

            scope.driverWorkHours.avg16WeekWorkTime.actualValue = commonTrackService.getTimeStringFromMinutes(_avg16WeekWorkTime, TIME_STRING_FORMAT._2);//getHourMinTranslatedString(data.selectedRow.worktimeavg16we);
            scope.driverWorkHours.avg16WeekWorkTime.value = _avg16WeekWorkTime;
            scope.driverWorkHours.workTimeTotal.type = getProgressBarType('workTimeTotal', _workTimeTotalMinutes);
            scope.driverWorkHours.workTimeTotal.value = getProgressPercentatge(_workTimeTotalMinutes, workTimeMaxLimitMinutes);
            scope.driverWorkHours.workTimeTotal.value = scope.driverWorkHours.workTimeTotal.value >= 0 ? scope.driverWorkHours.workTimeTotal.value : totalBar;
            scope.driverWorkHours.workTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.worktimetotal) : commonTrackService.getTimeStringFromMinutes(workTimeMaxLimitMinutes - _workTimeTotalMinutes);
            
            scope.driverWorkHours.driveTimeTotal.type = getProgressBarType('drivingTimeTotal', _driveTimeTotalMinutes);
            scope.driverWorkHours.driveTimeTotal.value = getProgressPercentatge(_driveTimeTotalMinutes, driveTimeTotalMaxLimitMinutes);
            scope.driverWorkHours.driveTimeTotal.value = scope.driverWorkHours.driveTimeTotal.value >= 0 ? scope.driverWorkHours.driveTimeTotal.value : totalBar;
            scope.driverWorkHours.driveTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.drivetimetotal) : commonTrackService.getTimeStringFromMinutes(driveTimeTotalMaxLimitMinutes - _driveTimeTotalMinutes);
            
            scope.driverWorkHours.driveTimePause.type = getProgressBarType('driveTimeBetweenPause', _driveTimeBetweenPauseTotalMinutes);
            scope.driverWorkHours.driveTimePause.value = getProgressPercentatge(_driveTimeBetweenPauseTotalMinutes, driveTimeBetweenPauseMaxLimitMinutes);
            scope.driverWorkHours.driveTimePause.value = scope.driverWorkHours.driveTimePause.value >= 0 ? scope.driverWorkHours.driveTimePause.value : totalBar;
            scope.driverWorkHours.driveTimePause.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.drivetimebetweenpause) : commonTrackService.getTimeStringFromMinutes(driveTimeBetweenPauseMaxLimitMinutes - _driveTimeBetweenPauseTotalMinutes);
            scope.driverWorkHours.workTimePause.type = getProgressBarType('workTimeBetweenPause', _workTimeBetweenPauseTotalMinutes);
            scope.driverWorkHours.workTimePause.value = getProgressPercentatge(_workTimeBetweenPauseTotalMinutes, workTimeBetweenPauseMaxLimitMinutes);
            scope.driverWorkHours.workTimePause.value = scope.driverWorkHours.workTimePause.value >= 0 ? scope.driverWorkHours.workTimePause.value : totalBar;
            scope.driverWorkHours.workTimePause.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.worktimebetweenpause) : commonTrackService.getTimeStringFromMinutes(workTimeBetweenPauseMaxLimitMinutes - _workTimeBetweenPauseTotalMinutes);

            // weekly details
            scope.driverWorkHours.weekWorkTimeTotal.type = getProgressBarType('weekWorkTimeTotal', _weekWorkTimeTotalMinutes);
            scope.driverWorkHours.weekWorkTimeTotal.value = getProgressPercentatge(_weekWorkTimeTotalMinutes, weeklyDetailWorkTimeTotalMaxLimitMinuts);
            scope.driverWorkHours.weekWorkTimeTotal.value = scope.driverWorkHours.weekWorkTimeTotal.value >= 0 ? scope.driverWorkHours.weekWorkTimeTotal.value : totalBar;
            scope.driverWorkHours.weekWorkTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? commonTrackService.getTimeStringFromMinutes(_weekWorkTimeTotalMinutes, TIME_STRING_FORMAT._2) : commonTrackService.getTimeStringFromMinutes(weeklyDetailWorkTimeTotalMaxLimitMinuts - _weekWorkTimeTotalMinutes, TIME_STRING_FORMAT._2);
            scope.driverWorkHours.weekDriveTimeTotal.type = getProgressBarType('weekDriveTimeTotal', _weekDriveTimeTotal);
            scope.driverWorkHours.weekDriveTimeTotal.value = getProgressPercentatge(_weekDriveTimeTotal, weeklyDetailDriveTimeTotalMaxLimitMinuts);
            scope.driverWorkHours.weekDriveTimeTotal.value = scope.driverWorkHours.weekDriveTimeTotal.value >= 0 ? scope.driverWorkHours.weekDriveTimeTotal.value : totalBar;
            scope.driverWorkHours.weekDriveTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? commonTrackService.getTimeStringFromMinutes(_weekDriveTimeTotal, TIME_STRING_FORMAT._2) : commonTrackService.getTimeStringFromMinutes(weeklyDetailDriveTimeTotalMaxLimitMinuts - _weekDriveTimeTotal, TIME_STRING_FORMAT._2);
            scope.driverWorkHours.weekDriveTimeTotal2we.type = getProgressBarType('weekDriveTimeTotal2we', _weekDriveTimeTotal2we);
            scope.driverWorkHours.weekDriveTimeTotal2we.value = getProgressPercentatge(_weekDriveTimeTotal2we, weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts);
            scope.driverWorkHours.weekDriveTimeTotal2we.value = scope.driverWorkHours.weekDriveTimeTotal2we.value >= 0 ? scope.driverWorkHours.weekDriveTimeTotal2we.value : totalBar;
            scope.driverWorkHours.weekDriveTimeTotal2we.actualValue = scope.timeRadio.type !== 'remainingTime' ? commonTrackService.getTimeStringFromMinutes(_weekDriveTimeTotal2we, TIME_STRING_FORMAT._2) : commonTrackService.getTimeStringFromMinutes(weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts - _weekDriveTimeTotal2we, TIME_STRING_FORMAT._2);

            scope.hasWeeklyRestData = false;
            scope.weeklyRestTimeDisplayColor = '';
            scope.weeklyRestTime1 = data.selectedRow.weeklyresttime1;
            scope.weeklyRestTime2 = data.selectedRow.weeklyresttime2;
            scope.weeklyRestTimeDisplayColor1 = '#555560'; // Black
            scope.weeklyRestTimeDisplayColor2 = '#555560'; // Black
            if(data.selectedRow.weeklyresttime1 !== undefined && data.selectedRow.weeklyresttime1 !== null && data.selectedRow.weeklyresttime1 !== '') {
              scope.hasWeeklyRestData = true;
            }
            if(data.selectedRow.weeklyresttimecolor1 === 'red') {
              scope.weeklyRestTimeDisplayColor1 = '#EF4136'; // Red
            }
            if(data.selectedRow.weeklyresttimecolor2 === 'red') {
              scope.weeklyRestTimeDisplayColor2 = '#EF4136'; // Red
            }

            scope.nextShiftStartsBeforeLabel = data.selectedRow.nextshiftstartdetail;
            scope.nextPauseDuriationDisplayColor = '';

            /**
             * next pause duration calculation , duration time and color details are calculated as per driver related data.
             */
            if ((_pauseTimeTotal === 0) && (_driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes >= _4_30_M)) {
              scope.nextPauseDuration = '45m';
              scope.nextPauseDuriationDisplayColor = '#EF4136'; // Red
            } else if ((_pauseTimeTotal === 0) && (_driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M)) {
              scope.nextPauseDuration = '15m/30m/45m';
            } else if ((_pauseTimeTotal > 0 && _pauseTimeTotal < 30) && (_driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M)) {
              scope.nextPauseDuration = '30m';
            } else if ((_pauseTimeTotal > 0 && _pauseTimeTotal >= 30) && (_driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M)) {
              scope.nextPauseDuration = '30m/45m';
            } else if ((_pauseTimeTotal > 0 && _pauseTimeTotal >= 45) && (_driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M)) {
              scope.nextPauseDuration = '---';
            } else if (((_pauseTimeTotal === 0) && (_driveTimeTotalMinutes === 0 && _workTimeBetweenPauseTotalMinutes > _6_0_M && _workTimeBetweenPauseTotalMinutes <= _9_0_M))) {
              scope.nextPauseDuration = '30m';
              scope.nextPauseDuriationDisplayColor = '#EF4136'; // Red
            } else if (((_pauseTimeTotal === 0) && (_driveTimeTotalMinutes === 0 && _workTimeBetweenPauseTotalMinutes > _9_0_M))) {
              scope.nextPauseDuration = '45m';
              scope.nextPauseDuriationDisplayColor = '#EF4136'; // Red
            } else {
              scope.nextPauseDuration = '---';
            }
            scope.dataLoadingFinished = true;
          }, 1000);
        }


        function getProgressPercentatge(totalTimeInMinutes, timeMaxLimitInMinutes) {
          if (scope.timeRadio.type === 'remainingTime') {
            totalTimeInMinutes = timeMaxLimitInMinutes - totalTimeInMinutes;
          }
          var wrkHrsPercentage = (totalTimeInMinutes / timeMaxLimitInMinutes) * 100;
          wrkHrsPercentage = wrkHrsPercentage > 0 ? wrkHrsPercentage : 0;
          return wrkHrsPercentage > 100 ? wrkHrsPercentage : wrkHrsPercentage;
        }


        /**
         * Base on the Case Selected the progress bar colour is calculated by their depending time.
         *
         * Each case value uses its own function to better  handling logic and Readability.
         *
         * @param workingType
         * @param time
         * @return String
         */
        function getProgressBarType(workingType, time) {
          switch (workingType) {
            case 'workTimeTotal':
              return _getWorkTimeTotalOrRemainingTimeProgressType(time);
            case 'drivingTimeTotal':
              return _getDriveTimeTotalOrRemainingTimeProgressType(time);
            case 'driveTimeBetweenPause':
              return _getDriveTimeBetweenPauseOrRemainingTimeProgressType(time);
            case 'workTimeBetweenPause':
              return _getWorkTimeBetweenPauseOrRemainingTimeProgressType(time);
            case 'weekWorkTimeTotal':
              return _getWeekWorkTimeTotalOrRemainingTimeProgressType(time);
            case 'weekDriveTimeTotal':
              return _getWeeDriveTimeTotalOrRemainingTimeProgressType(time);
            case 'weekDriveTimeTotal2we':
              return _getWeeDrive2TimeTotalOrRemainingTimeProgressType(time);
          }
        }

        /**
         *  returns progress bar type for the Total or Remaining  time of WORK TIME TOTAL.
         * @param time
         * @return string
         * @private
         */
        function _getWorkTimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWrkTime = workTimeMaxLimitMinutes - time;

            if ((_remainingWrkTime > _2_30_M) && (_remainingWrkTime <= _10_M)) {
              return 'success';
            }
            if ((_remainingWrkTime <= _2_30_M) && (_remainingWrkTime > 0)) {
              return 'warning';
            }
            return 'white';

          } else if (scope.timeRadio.type === 'totalTime') {

            if (time < _7_30_M) {
              return 'success';
            }
            if ((time > _7_30_M) && (time < _10_M)) {
              return 'warning';
            }
            if (time > _10_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of DRIVE TIME TOTAL.
         * @param time
         * @return string
         * @private
         */
        function _getDriveTimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingDrvTime = driveTimeTotalMaxLimitMinutes - time;

            if ((_remainingDrvTime > _1_30_M) && (_remainingDrvTime <= _10_M)) {
              return 'success';
            }
            if ((_remainingDrvTime <= _1_30_M) && (_remainingDrvTime > 0)) {
              return 'warning';
            }
            return 'white';

          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _8_30_M) {
              return 'success';
            }
            if ((time >= _8_30_M) && (time < _10_M)) {
              return 'warning';
            }
            if (time >= _10_M) {
              return 'danger';
            }
          }

        }

        /**
         *  returns progress bar type for the Total or Remaining  time of DRIVE TIME BETWEEN PAUSE.
         * @param time
         * @private
         * @return string
         */
        function _getDriveTimeBetweenPauseOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingDrvTimeBetPause = driveTimeBetweenPauseMaxLimitMinutes - time;

            if ((_remainingDrvTimeBetPause > 30) && (_remainingDrvTimeBetPause <= _4_30_M)) {
              return 'success';
            }
            if ((_remainingDrvTimeBetPause <= 30) && (_remainingDrvTimeBetPause > 0)) {
              return 'warning';
            }
            return 'white';

          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _4_M) {
              return 'success';
            }
            if ((time >= _4_M) && (time < _4_30_M)) {
              return 'warning';
            }
            if (time >= _4_30_M) {
              return 'danger';
            }
          }

        }

        /**
         * returns progress bar type for the Total or Remaining  time of WORK TIME BETWEEN PAUSE.
         * @param time
         * @private
         * @return string
         */
        function _getWorkTimeBetweenPauseOrRemainingTimeProgressType(time) {

          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWrkTimeBetPause = workTimeBetweenPauseMaxLimitMinutes - time;
            if ((_remainingWrkTimeBetPause > 30) && (_remainingWrkTimeBetPause <= _6_0_M)) {
              return 'success';
            }
            if ((_remainingWrkTimeBetPause <= 30) && (_remainingWrkTimeBetPause > 0)) {
              return 'warning';
            }
            return 'white';

          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _5_30_M) {
              return 'success';
            }
            if ((time >= _5_30_M) && (time < _6_0_M)) {
              return 'warning';
            }
            if (time >= _6_0_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of  WEEKLY WORK TIME.
         * @param time
         * @return string
         * @private
         */
        function _getWeekWorkTimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWeekWrkTimeTotal = weeklyDetailWorkTimeTotalMaxLimitMinuts - time;
            if ((_remainingWeekWrkTimeTotal > _12_0_M) && (_remainingWeekWrkTimeTotal <= _60_0_M)) {
              return 'success';
            }
            if ((_remainingWeekWrkTimeTotal <= _12_0_M) && (_remainingWeekWrkTimeTotal > 0)) {
              return 'warning';
            }
            return 'white';

          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _48_0_M) {
              return 'success';
            }
            if ((time >= _48_0_M) && (time < _60_0_M)) {
              return 'warning';
            }
            if (time >= _60_0_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of  WEEKLY DRIVE TIME.
         * @param time
         * @return string
         * @private
         */
        function _getWeeDriveTimeTotalOrRemainingTimeProgressType(time) {

          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWeekDrvTimeTotal = weeklyDetailDriveTimeTotalMaxLimitMinuts - time;
            if ((_remainingWeekDrvTimeTotal > _8_0_M) && (_remainingWeekDrvTimeTotal <= _56_0_M)) {
              return 'success';
            }
            if ((_remainingWeekDrvTimeTotal <= _8_0_M) && (_remainingWeekDrvTimeTotal > 0)) {
              return 'warning';
            }
            return 'white';

          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _48_0_M) {
              return 'success';
            }
            if ((time >= _48_0_M) && (time < _56_0_M)) {
              return 'warning';
            }
            if (time >= _56_0_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of  2 WEEK DRIVE TIME.
         * @param time
         * @return String
         * @private
         */
        function _getWeeDrive2TimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remaining2WeekDrvTimeTotal = weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts - time;
            if ((_remaining2WeekDrvTimeTotal > _10_M) && (_remaining2WeekDrvTimeTotal <= _90_0_M)) {
              return 'success';
            }
            if ((_remaining2WeekDrvTimeTotal <= _10_M) && (_remaining2WeekDrvTimeTotal > 0)) {
              return 'warning';
            }
            return 'white';

          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _80_0_M) {
              return 'success';
            }
            if ((time >= _80_0_M) && (time < _90_0_M)) {
              return 'warning';
            }
            if (time >= _90_0_M) {
              return 'danger';
            }
          }
        }

        function _convertGtsTimeStringToMinutes(timeString, skipMaximumdayLimit) {
          var _days = timeString.indexOf('d') !== -1 && timeString.split('d')[0] || 0;
          _days = Number(_days) > 1 && !skipMaximumdayLimit ? 1 : _days;
          timeString = timeString.length > 0 && timeString.indexOf('d') !== -1 ? timeString.split('d')[1] : timeString;
          var _sampleWrkhrsString = timeString.length > 0 ? timeString : '0h  0m';
          if (_days && _sampleWrkhrsString.beginsWith(' ')) {
            _sampleWrkhrsString = _sampleWrkhrsString.substr(1, _sampleWrkhrsString.length);
          }
          var _sampleWrkhrsStringArry = _sampleWrkhrsString.replace(' ', '.').replace(' ', '').replace(/h|m/g, '').split('.');
          return _sampleWrkhrsStringArry.length === 2 ? ((_days * 24) * 60) + Number(_sampleWrkhrsStringArry[0] * 60) + Number(_sampleWrkhrsStringArry[1]) : 0;
        }

        function _loopAndGetElements(sourcceElementArray, destinationArray) {
          for (var j = 0; j < sourcceElementArray.length; j++) {
            destinationArray.push(sourcceElementArray[j].outerHTML.replace('display="none"', ''));
          }
          return destinationArray;
        }

        function getHourMinTranslatedString(value) {
          return value.length > 0 ? value.replace('h', h).replace('m', m) : 0 + h + ' ' + 0 + m;
        }

        function getSvgElementByID(id) {
          return angular.element(getSvgDocument().getElementById(id));
        }

        /**
         * Used to update the SVG Circle both GREEN and RED based on the given type of working minutes .
         *
         *
         * @param workingOrDrivingMinutes
         * @param greenCircleElement
         * @param overAllPercentElement
         * @param redCircleElement
         */
        function updateSvgCircle(workingOrDrivingMinutes, greenCircleElement, overAllPercentElement, redCircleElement, totalMinutsLimit) {

          if (scope.timeRadio.type === 'remainingTime') {
            workingOrDrivingMinutes = totalMinutsLimit - workingOrDrivingMinutes > 0 ? totalMinutsLimit - workingOrDrivingMinutes : 0;

          }


          var _extraWrkHrs = workingOrDrivingMinutes > totalMinutsLimit ? workingOrDrivingMinutes - totalMinutsLimit : 0;

          workingOrDrivingMinutes = workingOrDrivingMinutes > totalMinutsLimit ? totalMinutsLimit : workingOrDrivingMinutes;
          var wrkHrsPercentage = (workingOrDrivingMinutes / totalMinutsLimit) * 100;
          var noOfCircleLinesToRemove = totalCircle - (Math.round((Math.round(wrkHrsPercentage) / 100) * totalCircle));

          wrkHrsPercentage = (Number()._isFloat(wrkHrsPercentage) && Number()._isFloat(wrkHrsPercentage.toFixed(2)) ? wrkHrsPercentage.toFixed(2) : Math.round(wrkHrsPercentage));

          // update overall percentage and remaining time
          overAllPercentElement.html(wrkHrsPercentage + '%');

          var _totalOrRemainngHours = parseInt(workingOrDrivingMinutes / 60);
          _totalOrRemainngHours = _totalOrRemainngHours.toString().length === 2 ? _totalOrRemainngHours : '0' + _totalOrRemainngHours;
          var _convertedMinutes = (workingOrDrivingMinutes % 60);
          _convertedMinutes = _convertedMinutes.toString().length === 2 ? _convertedMinutes : '0' + _convertedMinutes;
          updateCircleOrBar(greenCircleElement, noOfCircleLinesToRemove, greenWrkHrsCircleArry);

          if (_extraWrkHrs > 0) {
            updateExtraWrksHrs(_extraWrkHrs, redCircleElement);
          }
          //Bugfix 103799 - ensure _extraWrkHrs is in hours format here - to 1 decimal place
          _extraWrkHrs = (_extraWrkHrs/60).toFixed(1);
          _extraWrkHrs = _extraWrkHrs > 4 ? 4 : _extraWrkHrs;
          var remaingHourTextSvg = _extraWrkHrs > 0 ? '<tspan x="15" dy="0.8em" fill="#E85D10"> +' + _extraWrkHrs + '</tspan>' : '';
          getSvgElementByID(remaingWrktimeLabel).html(_totalOrRemainngHours + 'h' + ' ' + _convertedMinutes + 'm' + remaingHourTextSvg);

        }

        function updateExtraWrksHrs(extraWrkHrsMinutes, extrWrkHrsCircleElement) {
          extraWrkHrsMinutes = extraWrkHrsMinutes > totlExtraWrkHrsLimitMinutes ? totlExtraWrkHrsLimitMinutes : extraWrkHrsMinutes;
          var extrsWrkHrsPercentage = (extraWrkHrsMinutes / totlExtraWrkHrsLimitMinutes) * 100;
          var noOfCircleLinesToRemove = totalCircle - (Math.round((Math.round(extrsWrkHrsPercentage) / 100) * totalCircle));
          updateCircleOrBar(extrWrkHrsCircleElement, noOfCircleLinesToRemove, redWrkHrsCircleArry);
        }

        function updateCircleOrBar(element, noOfCircleLinesOrBarToRemove, elementArray) {
          $timeout(function () {
            for (var j = totalCircle; j >= noOfCircleLinesOrBarToRemove; j--) {
              element.append(elementArray[j]).hide().show('slow');
            }
          }, 0);
        }

        // Modification for the Loading Imporvement

        var loadDependentDataFromServer = function (deviceID) {
          scope.isDataNotAvailable = false;
          DriverWrkHrsWidgetService.getDriverWorkingHoursListForDevice(deviceID).then(function (result) {
            scope.dataLoadingFinished = true;

            if (result.dataList && result.dataList.length === 1) {
              scope.isDataFromHistoryList = false;
              DriverWrkHrsSVGWidgetService.setLastReadDeviceWorkingHours(result.dataList[0]);
              _handleRowSlectEvnt({ selectedRow: result.dataList[0] });
            } else {
              scope.isDataNotAvailable = true;
            }
          });
        };
        var getSetData = function (widget) {
          var loginID = AuthenticationService.GetLoginID();
          widget = loginID.Account+'_'+loginID.username +'_'+widget;
          var stateData = stateManagerService.getStateData();
          var set = stateData && stateData[widget] ? stateData[widget] : {};
          return set;
        };
        var maxGetInitialDataRetries = 30;
        var currentParentRowResEvent = scope.$on('resDataUpdate', function (event, data) {
          if (maxGetInitialDataRetries < 0 || scope.isWidgetPostInitFinished) {
            currentParentRowResEvent();
            return;
          }
          console.info(' Driver Working Status Widget Requesting Parent for Data ..');
          --maxGetInitialDataRetries;
          var set = getSetData(data.widget);
          var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];


          // parents First tab must always retrun a  valid selected row
          if ((data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value)) || (data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues))) {
            scope.isWidgetPreInitFinished = true;
            scope.isWidgetPostInitFinished = true;
            _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);

          } else {
            // Repeatedly try to get the data from parent .
            if (maxGetInitialDataRetries > 0) {
              $timeout(function () {
                if (!scope.isWidgetPostInitFinished) {
                  $rootScope.$broadcast('reqDataUpdate');
                }
              }, 100);
            } else {
              console.error('Max Retries exceeded to get the current Parent data for Driver Working Status Widget..');
              scope.isWidgetPreInitFinished = true;
              scope.isWidgetPostInitFinished = true;
              scope.isDataNotAvailable = true;
              currentParentRowResEvent();
            }
          }

        });

        var dataStateUpdateListener = scope.$on('dataStateUpdate', function (event, data) {
          if (scope.isWidgetPostInitFinished) {
            var set = getSetData(data.widget);
            _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
          } else {
            //console.log('Ignoring dataState update from widget: ' + data.widget);
          }

        });

        /*     var tachoHistoryWidgteDateEvent = scope.$on('tacho_detail_widget_event', function (event, data) {
              if (data.eventType === 'date_change') {
                var set = getSetData('tachoHistoryWidget');
                _handleDataUpdate('dashboard.tachohistory', 0, set['tab_' + 0 + '_selectedRow'].value, 'tachoHistoryWidget');
              } else {
                //console.log('Ignoring dataState update from widget: ' + data.widget);
              }

            }); */

        function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName) {
          var set;

          switch (dashboardName) {
            case 'dashboard.driverWrkHrsDashboard': // contains only tab 0
            case 'dashboard.tachohistory':
              switch (tabNumber) {
                case 0:
                  if (!_.isEmpty(rowData)) {
                    _handleRowSlectEvnt({ selectedRow: rowData });
                  } else {
                    scope.isDataNotAvailable = true;
                  }

                  break;
              }
              break;
            case 'dashboard.fmsDashboard':
            case 'dashboard.vehicleList':
              switch (tabNumber) {
                case 0: // first tab use device id to  load data from server
                  set = getSetData(widgetName);
                  rowData = set['tab_' + 0 + '_selectedRow'];
                  if (!_.isEmpty(rowData.value)) {
                    loadDependentDataFromServer(rowData.value.deviceid);
                  } else {
                    scope.isDataNotAvailable = true;
                  }
                  break;
                case 1: // use the Service stored Data
                case 2:
                case 3:
                  rowData = DriverWrkHrsSVGWidgetService.getLastReadDeviceWorkingHours();
                  if (!_.isEmpty(rowData)) {
                    _handleRowSlectEvnt({ selectedRow: rowData });
                  } else {
                    rowData = set['tab_' + 0 + '_selectedRow'];
                    if (!_.isEmpty(rowData.value)) {
                      loadDependentDataFromServer(rowData.value.deviceid);
                    } else {
                      scope.isDataNotAvailable = true;
                    }

                  }
                  break;
              }
              break;

          }
        }


        scope.$on('$destroy', function () {

          dataStateUpdateListener();
          currentParentRowResEvent();
          //tachoHistoryWidgteDateEvent();
        });

        scope.timeRadioTypeChange = function () {
          localStorageService.set('selectedWorkingHourType.' + loginid.Account + '.' + loginid.username, {
            workingHourType: scope.timeRadio.type,
            svgRadioType: scope.timeRadio.svgRadioType,
            viewType: {
              dailyView: scope.timeRadio.viewType.dailyView,
              weeklyView: scope.timeRadio.viewType.weeklyView
            }
          });
          _refreshSvgBasedOnLastSelectedData();
        };

        scope.svgRadioTypeChange = function () {
          localStorageService.set('selectedWorkingHourType.' + loginid.Account + '.' + loginid.username, {
            workingHourType: scope.timeRadio.type,
            svgRadioType: scope.timeRadio.svgRadioType,
            viewType: {
              dailyView: scope.timeRadio.viewType.dailyView,
              weeklyView: scope.timeRadio.viewType.weeklyView
            }
          });
          _refreshSvgBasedOnLastSelectedData();

        };
        scope.expandPane = function () {
          scope.isPaneExpanded = !scope.isPaneExpanded;
          if (scope.isPaneExpanded) {
            $('#collapse1').hide();

          } else {
            _refreshSvgBasedOnLastSelectedData();
            $('#collapse1').delay(100).show(0);


          }
        };
        scope.dataLoadingFinished = true;
      };


      if (getSvgDocument()) {
        init();

      } else {
        element.on('load', init);
      }

    }
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/driverWrkHrsSvgInterpreter.js